/**
 * Generic utility module.
 */


import Objects from 'utility/objects/objects.js';


/**
 * Class for generic utility functions.
 *
 * @class      Utility (name)
 */
export default class Utility
{
	/**
	 * Allow using objects as a submodule.
	 */
	static get Objects()
	{
		return Objects;
	}
};



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/utility/utility.js